angular
    .module('aq.integrations', ['aq.ui', 'aq.auth', 'aq.services', 'accounts', 'aq.settings']);
